import type { PlanValues } from 'api/elplan/elplan.types'
import { parseDecimalInput } from 'utils/stringUtils'

type SpotBidSaveValuesOptions = {
  inputMode: 'hourly' | '15-mins'
  hourKeys: string[]
  hourGroups: Record<string, PlanValues[]>
  quarterValues: Record<string, number[]>
  quarterStringValues: Record<string, string[]>
  quarterHourValues: Record<string, number[]>
  quarterHourStringValues: Record<string, string[]>
}

export function spotBidSaveValues({
  inputMode,
  hourKeys,
  hourGroups,
  quarterValues,
  quarterStringValues,
  quarterHourValues,
  quarterHourStringValues,
}: SpotBidSaveValuesOptions): PlanValues[] {
  const newPlanValues: PlanValues[] = []
  hourKeys.forEach((hourKey) => {
    const quarters = hourGroups[hourKey]
    const fallbackValues =
      inputMode === 'hourly'
        ? quarterHourValues[hourKey] || quarters.map((q) => q.volume)
        : quarterValues[hourKey] || quarters.map((q) => q.volume)
    quarters.forEach((quarter, index) => {
      const stringValue =
        inputMode === 'hourly' ? quarterHourStringValues[hourKey]?.[0] : quarterStringValues[hourKey]?.[index]
      const parsed = stringValue ? parseDecimalInput(stringValue) : 0
      newPlanValues.push({
        ...quarter,
        volume: stringValue && isNaN(parsed) ? fallbackValues[inputMode === 'hourly' ? 0 : index] : parsed,
      })
    })
  })
  return newPlanValues
}
